import React, { Component } from 'react';
import axios from 'axios';
import { uAPI } from '../config/Config';
import './assets/email-template.css';

const EMPTY = { id: null, template_key: 'RESERVATION', template_name: '', subject: '', html_body: '', is_active: 1 };
const TOKEN_HELP = '{ nama }, { ktp }, { hari }, { branch_name }, { patient_id }, { reservation_link }';

class EmailTemplate extends Component {
  state = { data: [], selected: null, form: EMPTY, loading: true, saving: false, preview: false, error: '' };

  componentDidMount() { this.load(); }

  load = async () => {
    this.setState({ loading: true, error: '' });
    try {
      const response = await axios.get(uAPI + '/api/v1/email-templates');
      const data = response.data && response.data.results ? response.data.results : [];
      this.setState({ data, loading: false }, () => {
        if (!this.state.selected && data.length) this.select(data[0]);
      });
    } catch (e) {
      this.setState({ loading: false, error: 'Gagal mengambil template email.' });
    }
  };

  select = (item) => this.setState({ selected: item.id, form: { ...item } });

  change = (e) => this.setState({ form: { ...this.state.form, [e.target.name]: e.target.value } });

  save = async () => {
    const { form } = this.state;
    if (!form.template_name || !form.subject || !form.html_body) {
      this.setState({ error: 'Nama template, subject dan HTML wajib diisi.' });
      return;
    }
    this.setState({ saving: true, error: '' });
    try {
      await axios.put(uAPI + '/api/v1/email-templates/' + form.id, {
        template_name: form.template_name,
        subject: form.subject,
        html_body: form.html_body,
        is_active: Number(form.is_active) === 1
      });
      await this.load();
      this.setState({ saving: false });
      window.alert('Template berhasil disimpan. Email berikutnya akan menggunakan konten terbaru.');
    } catch (e) {
      this.setState({ saving: false, error: 'Gagal menyimpan template email.' });
    }
  };

  create = () => this.setState({ selected: null, form: { ...EMPTY, template_key: 'CUSTOM_' + Date.now(), template_name: 'Template Baru' } });

  add = async () => {
    const { form } = this.state;
    if (!form.template_name || !form.subject || !form.html_body) return this.setState({ error: 'Lengkapi semua field wajib.' });
    this.setState({ saving: true, error: '' });
    try {
      await axios.post(uAPI + '/api/v1/email-templates', { ...form, is_active: Number(form.is_active) === 1 });
      await this.load();
      this.setState({ saving: false });
    } catch (e) { this.setState({ saving: false, error: 'Gagal menambah template.' }); }
  };

  remove = async () => {
    if (!this.state.form.id || !window.confirm('Hapus template ini?')) return;
    try {
      await axios.delete(uAPI + '/api/v1/email-templates/' + this.state.form.id);
      await this.load();
    } catch (e) { this.setState({ error: 'Template sistem tidak dapat dihapus atau terjadi kesalahan.' }); }
  };

  render() {
    const { data, form, selected, loading, saving, preview, error } = this.state;
    return <div className="email-template-page">
      <div className="template-hero">
        <div><span className="eyebrow">EMAIL CONTENT CONTROL</span><h2>Subject & HTML Email</h2><p>Ubah judul dan isi email reservasi, booking, dan reschedule tanpa menyentuh source code.</p></div>
        <div className="template-actions"><button onClick={this.create}>+ Template Baru</button><button className="ghost" onClick={this.load}>↻ Refresh</button></div>
      </div>
      {error && <div className="template-error">{error}</div>}
      <div className="template-grid">
        <aside className="template-list">
          <div className="list-title">Template Email <span>{data.length}</span></div>
          {loading ? <div className="template-empty">Memuat...</div> : data.map(item => <button key={item.id} className={selected === item.id ? 'template-item active' : 'template-item'} onClick={() => this.select(item)}><span>{item.template_name}</span><small>{item.template_key}</small></button>)}
        </aside>
        <section className="template-editor">
          <div className="editor-top"><div><small>KEY</small><strong>{form.template_key || '-'}</strong></div><label className="switch"><input type="checkbox" checked={Number(form.is_active) === 1} onChange={e => this.setState({ form: { ...form, is_active: e.target.checked ? 1 : 0 } })}/><span></span> Aktif</label></div>
          <label>Nama Template<input name="template_name" value={form.template_name || ''} onChange={this.change}/></label>
          <label>Subject Email<input name="subject" value={form.subject || ''} onChange={this.change}/></label>
          <div className="token-help"><strong>Placeholder:</strong> {TOKEN_HELP}</div>
          <label>HTML Body<textarea name="html_body" rows="18" value={form.html_body || ''} onChange={this.change}/></label>
          <div className="editor-actions"><button className="primary" disabled={saving || !form.id} onClick={this.save}>{saving ? 'Menyimpan...' : 'Simpan Perubahan'}</button><button onClick={() => this.setState({ preview: !preview })}>{preview ? 'Tutup Preview' : 'Preview'}</button>{form.id && !['RESERVATION','BOOKING','RESCHEDULE'].includes(form.template_key) && <button className="danger" onClick={this.remove}>Hapus</button>}{!form.id && <button className="primary" onClick={this.add}>Simpan Template Baru</button>}</div>
          {preview && (
            <div className="email-preview">
              <div
                dangerouslySetInnerHTML={{
                  __html: (form.html_body || '')
                    .replace(/\{\{nama\}\}/g, 'Bapak/Ibu Peserta')
                    .replace(/\{\{ktp\}\}/g, '3170000000000000')
                    .replace(/\{\{hari\}\}/g, 'Senin, 20 Oktober 2025')
                    .replace(/\{\{branch_name\}\}/g, 'Bio Medika Kedoya')
                    .replace(/\{\{patient_id\}\}/g, 'BMCU1809260001')
                    .replace(/\{\{reservation_link\}\}/g, 'https://reg.biomedika.co.id/book-new')
                }}
              />
            </div>
          )}
        </section>
      </div>
    </div>;
  }
}

export default EmailTemplate;
